import { AxiosResponse, AxiosError } from "axios";
import api from "@services/axios/apiManager";

/** PATCH /app-api/customer/contexts/:context_id 回傳的更新後 context（精簡） */
export interface RenamedContext {
  context_id: number;
  context_name: string;
}

type RenameContextResult =
  | { state: "success"; data: RenamedContext }
  | { state: "error"; error: string };

/**
 * 更新 context 名稱（customer_context.context_name）。
 * 權限：只有 owner 能改、context 必須 active（後端驗，失敗回對應錯誤訊息）。
 */
export const handleAPIRenameContext = async (
  contextId: string | number,
  contextName: string,
  cusJwtToken: string,
): Promise<RenameContextResult> => {
  try {
    const res: AxiosResponse = await api.patch(
      `/app-api/customer/contexts/${contextId}`,
      { context_name: contextName },
      { headers: { Authorization: `Bearer ${cusJwtToken}` } },
    );
    return { state: "success", data: res.data?.data as RenamedContext };
  } catch (error) {
    const axiosError = error as AxiosError;
    const message =
      (axiosError.response?.data as { message?: string } | undefined)?.message ||
      axiosError.message ||
      "更新失敗";
    return { state: "error", error: message };
  }
};

/** DELETE /app-api/customer/contexts/:context_id/members/:customer_id 回傳 */
export interface KickedMember {
  customer_id: number;
}

type KickMemberResult =
  | { state: "success"; data: KickedMember }
  | { state: "error"; error: string };

/**
 * 將成員移出 context（customer_context_member）。
 * 權限：只有 owner 能移除；不可移除負責人本身 / 最後一位成員（後端驗，失敗回對應錯誤訊息）。
 */
export const handleAPIKickMember = async (
  contextId: string | number,
  targetCustomerId: number,
  cusJwtToken: string,
): Promise<KickMemberResult> => {
  try {
    const res: AxiosResponse = await api.delete(
      `/app-api/customer/contexts/${contextId}/members/${targetCustomerId}`,
      { headers: { Authorization: `Bearer ${cusJwtToken}` } },
    );
    return { state: "success", data: res.data?.data as KickedMember };
  } catch (error) {
    const axiosError = error as AxiosError;
    const message =
      (axiosError.response?.data as { message?: string } | undefined)?.message ||
      axiosError.message ||
      "移除失敗";
    return { state: "error", error: message };
  }
};
